var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1550 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "epicGlow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 18,
    floodColor: "#7C3AED",
    floodOpacity: 0.55
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 6,
    floodColor: "#D946EF",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyberViolet",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6D28D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D946EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "techFusion",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D946EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#C084FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E2E8F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "platinumChrome",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CBD5E1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#epicGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cyberViolet)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "       M90 70       H190       C245 70 285 110 285 160       C285 210 245 250 190 250       H90       V70       ZM134 106       V214       H182       C215 214 241 192 241 160       C241 128 215 106 182 106       H134       Z     "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#cyberViolet)",
    d: "       M320 70       H430       V106       H364       V142       H420       V178       H364       V214       H430       V250       H320       V70       Z     "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#epicGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#techFusion)",
    d: "       M465 70       L545 250       H585       L665 70       H621       L565 194       L509 70       H465       Z     "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#platinumChrome)",
    filter: "url(#epicGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 695,
    y: 70,
    width: 40,
    height: 180,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "       M765 70       H905       V106       H853       V250       H813       V106       H765       V70       Z     "
  }), /*#__PURE__*/React.createElement("path", {
    d: "       M935 70       H1075       V106       H1023       V250       H983       V106       H935       V70       Z     "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "       M1195 70       C1247.45 70 1290 110.3 1290 160       C1290 209.7 1247.45 250 1195 250       C1142.55 250 1100 209.7 1100 160       C1100 110.3 1142.55 70 1195 70       ZM1195 106       C1164.07 106 1140 129.88 1140 160       C1140 190.12 1164.07 214 1195 214       C1225.93 214 1250 190.12 1250 160       C1250 129.88 1225.93 106 1195 106       Z     "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#platinumChrome)",
    strokeWidth: 13,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#epicGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1365 115L1320 160L1365 205"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415 95L1385 225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 115L1480 160L1435 205"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a53945cee6b0d36d401a1fafa89ac267.svg";
export { ForwardRef as ReactComponent };